<template>
  <div class="promotion-raffles-form">
    <a-spin :spinning="loading" :tip="labels.form.loading">
      <ValidationObserver ref="observer">
        <a-form
          :model="form"
          :label-width="80"
          slot-scope="{ validate }"
          @submit.prevent="validate().then(handleSubmit)"
        >
          <a-row
            type="flex"
            justify="space-between"
            :gutter="16"
            :style="{ marginBottom: '15px' }"
          >
            <!-- Title -->
            <a-col :xs="24" :md="12">
              <h2 class="form-title">
                <a-icon :type="isEdit ? 'edit' : 'form'" class="form-icon" />
                <span>{{
                  isEdit
                    ? `${labels.form.titleView} número: ${form.code || ""}`
                    : labels.form.titleProcess
                }}</span>
              </h2>
            </a-col>
            <!-- Actions -->
            <a-col :xs="24" :md="12">
              <a-row
                type="flex"
                justify="end"
                :gutter="16"
                :style="{
                  alignItems: 'flex-end',
                  marginBottom: '0px',
                }"
              >
                <a-col>
                  <a-button-group>
                    <a-button
                      :type="isEdit ? 'primary' : 'danger'"
                      ghost
                      @click="handleCancel"
                      icon="arrow-left"
                    >
                      <span>{{ labels.form.goBack }}</span>
                    </a-button>
                    <a-button
                      v-if="isEdit && canInitiate"
                      type="primary"
                      @click="confirmInitiate"
                    >
                      <span>{{ labels.form.initiateRaffle }}</span>
                    </a-button>
                    <a-button
                      v-if="isEdit && canClose"
                      type="danger"
                      @click="confirmClose"
                    >
                      <span>{{ labels.form.closeRaffle }}</span>
                    </a-button>
                    <a-button
                      v-if="!isMobile && canEdit"
                      type="primary"
                      ghost
                      :loading="submitting"
                      @click="validate().then(() => handleSubmit(true))"
                    >
                      <span>{{ labels.form.saveAndClose }}</span>
                    </a-button>
                    <a-button
                      v-if="canEdit"
                      type="primary"
                      :loading="submitting"
                      @click="validate().then(handleSubmit)"
                    >
                      <span>{{ labels.form.save }}</span>
                    </a-button>
                    <a-button
                      v-if="showPayButton"
                      type="primary"
                      :loading="paying"
                      :disabled="paying"
                      @click="confirmHandlePay"
                    >
                      <span>{{ labels.form.pay }}</span>
                    </a-button>
                    <a-dropdown :trigger="['click']" v-if="isMobile && canEdit">
                      <a-menu slot="overlay">
                        <a-menu-item
                          key="1"
                          @click="validate().then(() => handleSubmit(true))"
                          >{{ labels.form.saveAndClose }}</a-menu-item
                        >
                      </a-menu>
                      <a-button type="primary" ghost icon="more" />
                    </a-dropdown>
                  </a-button-group>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" justify="center">
            <a-col :span="24">
              <a-card>
                <a-row type="flex" justify="start">
                  <a-col :xs="24" :sm="24" :md="12">
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          v-model="form.name"
                          :vid="labels.form.name.label"
                          :label="labels.form.name.label"
                          :name="labels.form.name.label"
                          :formitem="{ label: labels.form.name.label }"
                          :placeholder="labels.form.name.placeholder"
                          rules="required"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.raffle_type"
                          :placeholder="labels.form.raffle_type.placeholder"
                          :label="labels.form.raffle_type.label"
                          :dataSource="raffle_types"
                          :allowClear="true"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="24">
                        <select-pagination
                          v-model="form.only_referred_by"
                          :fetchService="fetchUsers"
                          :placeholder="
                            labels.form.only_referred_by.placeholder
                          "
                          :labelKey="'fullname'"
                          :valueKey="'id'"
                          :label="labels.form.only_referred_by.label"
                          :disabledDefaultFetchOptions="false"
                          :allowClear="true"
                          mode="multiple"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.start_sequence"
                          :vid="labels.form.start_sequence.label"
                          :label="labels.form.start_sequence.label"
                          :name="labels.form.start_sequence.label"
                          :formitem="{
                            label: labels.form.start_sequence.label,
                          }"
                          :placeholder="labels.form.start_sequence.placeholder"
                          :min="0"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.end_sequence"
                          :vid="labels.form.end_sequence.label"
                          :label="labels.form.end_sequence.label"
                          :name="labels.form.end_sequence.label"
                          :formitem="{ label: labels.form.end_sequence.label }"
                          :placeholder="labels.form.end_sequence.placeholder"
                          :min="form.start_sequence ? form.start_sequence : 0"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-pagination
                          ref="lotterySelect"
                          v-model="form.lottery"
                          :fetchService="fetchLotteries"
                          :placeholder="labels.form.lottery.placeholder"
                          :labelKey="'name'"
                          :valueKey="'id'"
                          :disabledDefaultFetchOptions="false"
                          :label="labels.form.lottery.label"
                          :allowClear="true"
                          :customStyle="{ width: '100%' }"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.play_type"
                          :placeholder="labels.form.play_type.placeholder"
                          :label="labels.form.play_type.label"
                          :dataSource="play_types"
                          :allowClear="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <select-validation
                          v-model="form.prize_type"
                          :placeholder="labels.form.prize_type.placeholder"
                          :label="labels.form.prize_type.label"
                          :dataSource="prize_types"
                          :allowClear="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          v-if="form.prize_type === 'CASH'"
                          type="number"
                          v-model="form.prize_amount"
                          :vid="labels.form.prize_amount.label"
                          :label="
                            form.raffle_type === 'non_winning_orders'
                              ? labels.form.prize_amount.label2
                              : labels.form.prize_amount.label
                          "
                          :name="labels.form.prize_amount.label"
                          :formitem="{
                            label: labels.form.prize_amount.label,
                          }"
                          :placeholder="labels.form.prize_amount.placeholder"
                          :min="1"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                        <Input
                          v-else-if="form.prize_type === 'PRODUCT'"
                          v-model="form.prize_product"
                          :vid="labels.form.prize_product.label"
                          :label="labels.form.prize_product.label"
                          :name="labels.form.prize_product.label"
                          :formitem="{ label: labels.form.prize_product.label }"
                          :placeholder="labels.form.prize_product.placeholder"
                          rules="required"
                          :readOnly="!canEdit"
                        />
                      </a-col>
                    </a-row>

                    <a-row
                      v-if="form.prize_type === 'PRODUCT'"
                      type="flex"
                      justify="space-between"
                      :gutter="24"
                    >
                      <a-col :xs="24" :sm="24" :md="24">
                        <Input
                          v-model="form.prize_product_image"
                          :vid="labels.form.prize_product_image.label"
                          :label="labels.form.prize_product_image.label"
                          :name="labels.form.prize_product_image.label"
                          :formitem="{
                            label: labels.form.prize_product_image.label,
                          }"
                          :placeholder="
                            labels.form.prize_product_image.placeholder
                          "
                          :readOnly="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="24">
                        <text-area
                          v-model="form.prize_product_description"
                          rules="required"
                          vid="message"
                          :placeholder="
                            labels.form.prize_product_description.placeholder
                          "
                          size="large"
                          :allowClear="true"
                          :readOnly="!canEdit"
                          :label="labels.form.prize_product_description.label"
                          :autoSize="{ minRows: 2, maxRows: 6 }"
                        />
                      </a-col>
                    </a-row>

                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <DatePicker
                          v-model="form.start_date"
                          :vid="labels.form.start_date.label"
                          :name="labels.form.start_date.label"
                          :formitem="{ label: labels.form.start_date.label }"
                          :placeholder="labels.form.start_date.placeholder"
                          :format="dateFormat"
                          :showTime="true"
                          rules="required"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <DatePicker
                          v-model="form.end_date"
                          :vid="labels.form.end_date.label"
                          :name="labels.form.end_date.label"
                          :formitem="{ label: labels.form.end_date.label }"
                          :placeholder="labels.form.end_date.placeholder"
                          :format="dateFormat"
                          :showTime="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>
                    <a-row type="flex" justify="space-between" :gutter="24">
                      <a-col :xs="24" :sm="24" :md="12">
                        <DatePicker
                          v-model="form.raffle_date"
                          :vid="labels.form.raffle_date.label"
                          :name="labels.form.raffle_date.label"
                          :formitem="{ label: labels.form.raffle_date.label }"
                          :placeholder="labels.form.raffle_date.placeholder"
                          :format="dateFormat"
                          :showTime="true"
                          :disabled="!canEdit"
                        />
                      </a-col>
                      <a-col :xs="24" :sm="24" :md="12">
                        <Input
                          type="number"
                          v-model="form.amount_per_ticket"
                          :vid="labels.form.amount_per_ticket.label"
                          :label="
                            form.raffle_type === 'non_winning_orders'
                              ? labels.form.amount_per_ticket.label2
                              : labels.form.amount_per_ticket.label
                          "
                          :name="labels.form.amount_per_ticket.label"
                          :formitem="{
                            label: labels.form.amount_per_ticket.label,
                          }"
                          :placeholder="
                            labels.form.amount_per_ticket.placeholder
                          "
                          :min="1"
                          rules="required"
                          :readOnly="!canEdit"
                          :disabled="!canEdit"
                        />
                      </a-col>
                    </a-row>
                    <a-row
                      type="flex"
                      justify="center"
                      :style="{ alignItems: 'center' }"
                      :gutter="[24, 24]"
                    >
                      <a-col :span="24">
                        <TextArea
                          v-model="form.comments"
                          rules="required"
                          vid="message"
                          :placeholder="labels.form.comments.placeholder"
                          size="large"
                          :allowClear="true"
                          :readOnly="!canEdit"
                          :label="labels.form.comments.label"
                          :autoSize="{ minRows: 2, maxRows: 6 }"
                        />
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-card>
            </a-col>
          </a-row>
        </a-form>
      </ValidationObserver>
    </a-spin>
    <!-- TICKETS LIST LOADER -->
    <template v-if="isEdit">
      <a-button
        type="primary"
        :style="{ marginTop: '15px' }"
        :loading="loading"
        block
        ghost
        :icon="loading ? 'loading' : 'reload'"
        @click="showTickets = !showTickets"
        >{{
          showTickets ? labels.form.loadTickets : labels.form.hideTickets
        }}</a-button
      >
      <a-row v-if="showTickets" :style="{ marginTop: '10px' }">
        <a-col
          :span="24"
          :class="{ 'radio-mobile-view': isMobile, 'radio-view': !isMobile }"
        >
          <a-radio-group
            :default-value="ONLY.ALL"
            @change="handleFilterTable"
            button-style="solid"
          >
            <a-radio-button :value="ONLY.ALL">
              {{ labels.form.only[ONLY.ALL] }}
            </a-radio-button>
            <a-radio-button :value="ONLY.TAKEN">
              {{ labels.form.only[ONLY.TAKEN] }}
            </a-radio-button>
            <a-radio-button :value="ONLY.AVAILABLE">
              {{ labels.form.only[ONLY.AVAILABLE] }}
            </a-radio-button>
          </a-radio-group>
        </a-col>
        <a-col :span="24">
          <StandardTable
            ref="standardTable"
            size="small"
            :fetchService="handleFetchPromotionRaffleTickets"
            :columns="columns"
            :locale="locale"
            :handleShowTotal="handleShowTotal"
            v-bind="!isMobile && { scroll: { x: true } }"
            :paginationType="isMobile ? 'arrows' : 'numbers'"
            :showSizeChanger="true"
            :pageSizeOptions="['10', '20', '50', '100']"
            :rowKey="'ticket_number'"
          />
        </a-col>
      </a-row>
    </template>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import labels from "@/utils/labels";
import Input from "@/components/core/VeeValidateForm/Input.vue";
import DatePicker from "@/components/core/VeeValidateForm/DatePicker.vue";
import TextArea from "@/components/core/VeeValidateForm/TextArea.vue";
import StandardTable from "@/components/core/table/StandardTable.vue";
import SelectPagination from "@/components/core/SelectPagination/index.vue";
import SelectValidation from "@/components/core/VeeValidateForm/Select.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import moment from "moment";
import router from "@/router";
import { mask } from "vue-the-mask";
import {
  adminPageTitle,
  DATE_FORMAT,
  hasRoles,
  roles,
} from "../../../utils/utils";
import { isEmpty } from "lodash";
import { RouterLink } from "vue-router";
import { h } from "vue";

const RAFFLE_STATUS = {
  PENDING: "PENDING",
  INITIATED: "INITIATED",
  CLOSED: "CLOSED",
  CONFIRMED: "CONFIRMED",
  PROCESSING: "PROCESSING",
};

const initialFormState = {
  name: "",
  raffle_type: "deposit_transaction",
  start_sequence: 0,
  end_sequence: 0,
  start_date: moment().startOf("day"),
  end_date: moment().endOf("day"),
  raffle_date: moment().endOf("day"),
  amount_per_ticket: 0,
  comments: "",
  status: RAFFLE_STATUS.PENDING,
  winning_ticket: "",
  only_referred_by: [],
  lottery: null,
  play_type: null,
  prize_type: null,
  prize_amount: 0,
  prize_product: "",
  prize_product_image: "",
  prize_product_description: "",
};

const ONLY = {
  ALL: "all",
  TAKEN: "taken",
  AVAILABLE: "available",
};

export default {
  name: "PromotionRaffleForm",
  directives: { themask: mask },
  components: {
    ValidationObserver,
    Input,
    DatePicker,
    TextArea,
    StandardTable,
    SelectPagination,
    SelectValidation,
  },
  metaInfo: {
    title: adminPageTitle(labels.promotionRaffles.title),
    titleTemplate: () => {
      return `${adminPageTitle()} - ${
        router.currentRoute.name.includes("view")
          ? labels.promotionRaffles.pageTitleViewing
          : labels.promotionRaffles.pageTitleCreate
      }`;
    },
  },
  filters: {
    ucwords(value) {
      if (!value) return "";
      value = value.toString();
      return value
        .split(" ")
        .map((item) => _.capitalize(item))
        .join(" ");
    },
  },
  data() {
    return {
      labels: labels.promotionRaffles,
      loading: false,
      paying: false,
      submitting: false,
      type: undefined,
      form: _.cloneDeep(initialFormState),
      showTickets: false,
      ONLY,
      raffle_types: [
        {
          label: labels.promotionRaffles.form.raffle_type.deposit_transaction,
          value: "deposit_transaction",
        },
        {
          label: labels.promotionRaffles.form.raffle_type.non_winning_orders,
          value: "non_winning_orders",
        },
      ],
      prize_types: [
        {
          label: labels.promotionRaffles.form.prize_type.cash,
          value: "CASH",
        },
        {
          label: labels.promotionRaffles.form.prize_type.product,
          value: "PRODUCT",
        },
      ],
      play_types: [
        {
          label: labels.promotionRaffles.form.play_type.pick3,
          value: "pick3",
        },
        {
          label: labels.promotionRaffles.form.play_type.pick4,
          value: "pick4",
        },
      ],
    };
  },
  async created() {
    this.resetForm();
    if (this.$route.params.id) {
      this.fetchData();
    }
  },
  computed: {
    ...mapState("promotionRaffles", ["promotionRaffle"]),
    ...mapState("layout", ["screenWidth"]),
    ...mapGetters("adminAuth", ["getLoggedUser"]),
    isEdit() {
      return !!this.$route.params?.id;
    },
    locale() {
      return {
        emptyText: this.labels.table.ticketEmptyText,
      };
    },
    canEdit() {
      const { accessRoles } = this.getLoggedUser;
      if (this.promotionRaffle?.status === RAFFLE_STATUS.CLOSED) {
        return false;
      }
      return (
        !this.isEdit ||
        hasRoles(accessRoles, [roles.admin.ROLE_PROMOTION_RAFFLES_UPDATE])
      );
    },
    canClose() {
      if (this.promotionRaffle?.status === RAFFLE_STATUS.CLOSED) {
        return false;
      }
      const { accessRoles } = this.getLoggedUser;
      return hasRoles(accessRoles, [roles.admin.ROLE_PROMOTION_RAFFLES_CLOSE]);
    },
    canInitiate() {
      const { accessRoles } = this.getLoggedUser;
      return (
        hasRoles(accessRoles, [roles.admin.ROLE_PROMOTION_RAFFLES_INITIATE]) &&
        this.form?.status === RAFFLE_STATUS.PENDING
      );
    },
    canPay() {
      const { accessRoles } = this.getLoggedUser;
      return hasRoles(accessRoles, [roles.admin.ROLE_PROMOTION_RAFFLE_PAY]);
    },
    showPayButton() {
      return (
        this.isEdit &&
        this.canPay &&
        this.promotionRaffle?.status === RAFFLE_STATUS.CLOSED &&
        this.promotionRaffle?.winning_ticket &&
        this.promotionRaffle?.winning_ticket !== "" &&
        this.promotionRaffle?.prize_type === "CASH" &&
        _.isEmpty(this.promotionRaffle?.transaction)
      );
    },
    dateFormat() {
      return "DD/MM/YYYY HH:mm:ss";
    },
    serverDateFormat() {
      return "YYYY-MM-DD HH:mm:ss";
    },
    money() {
      return {
        decimal: ".",
        thousands: ",",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      };
    },
    isMobile() {
      return this.screenWidth < 768;
    },
    columns() {
      return [
        {
          title: this.labels.table.columns.date,
          dataIndex: "date",
          key: "date",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return this.$moment(text).format("DD/MM/YYYY HH:mm:ss");
          },
        },
        {
          title: this.labels.table.columns.ticket_number,
          dataIndex: "ticket_number",
          key: "ticket_number",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return `${text}`;
          },
        },
        {
          title: this.labels.table.columns.reference,
          dataIndex: "reference",
          key: "reference",
          sorter: true,
          hidden: this.isMobile,
          customRender: (_, record) => {
            const isTransaction = !isEmpty(record.transaction);
            const isTicket = !isEmpty(record.ticket);
            if (isTransaction) {
              return h(
                RouterLink,
                {
                  props: {
                    to: {
                      name: "admin.transactions.view",
                      params: { id: record.transaction.id },
                    },
                  },
                },
                record.transaction.code
              );
            } else if (isTicket) {
              return h(
                RouterLink,
                {
                  props: {
                    to: {
                      name: "admin.tickets.view",
                      params: { id: record.ticket.id },
                    },
                  },
                },
                record.ticket.number
              );
            }
            return "--";
          },
        },
        {
          title: this.labels.table.columns.status.title,
          dataIndex: "status",
          key: "status",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            const color =
              text === "WINNER"
                ? "green"
                : text === "PENDING"
                ? "#ffc107"
                : "blue";
            const label =
              text === "WINNER"
                ? "Ganador"
                : text === "PENDING"
                ? "Pendiente"
                : "Perdedor";
            return text ? <a-tag color={color}>{label}</a-tag> : "--";
          },
        },
        {
          title: this.labels.table.columns.tickets,
          dataIndex: "tickets",
          key: "tickets",
          sorter: false,
          hidden: !this.isMobile,
          customRender: (_, record) => {
            // Card item design
            const color =
              record?.status === "WINNER"
                ? "green"
                : record?.status === "PENDING"
                ? "#ffc107"
                : "blue";
            const label =
              record?.status === "WINNER"
                ? "Ganador"
                : record?.status === "PENDING"
                ? "Pendiente"
                : "Perdedor";
            const reference = () => {
              const isTransaction = !isEmpty(record.transaction);
              const isTicket = !isEmpty(record.ticket);
              if (isTransaction) {
                return h(
                  RouterLink,
                  {
                    props: {
                      to: {
                        name: "admin.transactions.view",
                        params: { id: record.transaction.id },
                      },
                    },
                  },
                  record.transaction.code
                );
              } else if (isTicket) {
                return h(
                  RouterLink,
                  {
                    props: {
                      to: {
                        name: "admin.tickets.view",
                        params: { id: record.ticket.id },
                      },
                    },
                  },
                  record.ticket.number
                );
              }
              return "--";
            };
            return (
              <div class="list-item">
                <div class="list-item-head">
                  <div
                    class="list-item-head-header"
                    style={{ borderColor: color }}
                  >
                    <span>
                      {this.$options.filters.ucwords(
                        this.$moment(record.date).format(
                          DATE_FORMAT.MOMENT_DAY_MONTH_YEAR
                        )
                      )}
                    </span>
                    <small>
                      {this.$moment(record.date)
                        .format(DATE_FORMAT.MOMENT_TIME)
                        .toUpperCase()}
                    </small>
                  </div>
                  <div class="list-item-head-content">
                    <div class="list-item-head-content-ticket_number">
                      <span>{record.ticket_number}</span>
                    </div>
                    <div class="list-item-head-content-reference">
                      <span>{reference()}</span>
                    </div>
                  </div>
                  <div class="list-item-head-footer">
                    <div class="list-item-head-footer-status">
                      <a-tag color={color}>{label}</a-tag>
                    </div>
                  </div>
                </div>
              </div>
            );
          },
        },
      ].filter((column) => !column.hidden);
    },
  },
  methods: {
    ...mapActions("promotionRaffles", [
      "fetchPromotionRaffleTickets",
      "fetchPromotionRaffle",
      "createPromotionRaffle",
      "updatePromotionRaffle",
      "closePromotionRaffle",
      "payPromotionRaffle",
      "resetForm",
    ]),
    ...mapActions("lotteries", ["fetchLotteries"]),
    ...mapActions("users", ["fetchUsers"]),
    handleShowTotal(total, range) {
      return `${range[0]}-${range[1]} de ${total}`;
    },
    async handleFetchPromotionRaffleTickets(params) {
      return await this.fetchPromotionRaffleTickets({
        ...params,
        raffleId: this.$route.params.id,
      });
    },
    handleFilterTable(event) {
      let filtersTable = this.$refs.standardTable.filters;
      let result = { ...filtersTable };
      this.$refs.standardTable.handleFilters({
        ...result,
        only: event.target.value,
      });
    },
    async fetchData() {
      try {
        this.loading = true;
        await this.fetchPromotionRaffle(this.$route.params.id);
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
        this.$log.error(error);
        this.$router.push({ name: "admin.promotion-raffles" });
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit(closeAfterSave = false) {
      if (this.submitting) return;
      this.submitting = true;
      let response = null;
      let editting = this.isEdit;
      try {
        const formData = _.cloneDeep(this.form);
        formData.start_date = moment(formData.start_date).format(
          this.serverDateFormat
        );
        if (formData.end_date) {
          formData.end_date = moment(formData.end_date).format(
            this.serverDateFormat
          );
        } else {
          delete formData.end_date;
        }
        if (formData.raffle_date) {
          formData.raffle_date = moment(formData.raffle_date).format(
            this.serverDateFormat
          );
        } else {
          delete formData.end_date;
        }

        if (formData?.only_referred_by?.length) {
          formData.only_referred_by = formData.only_referred_by.map(
            (user) => user.id
          );
        } else {
          formData.only_referred_by = [];
        }

        response = editting
          ? await this.updatePromotionRaffle(formData)
          : await this.createPromotionRaffle(formData);

        if (response) this.$message.success(response.message);
        if (closeAfterSave) {
          this.$router.push({ name: "admin.promotion-raffles" });
        } else {
          if (!editting) {
            this.$router.push({
              name: "admin.promotion-raffles.edit",
              params: { id: response.data.id },
            });
          }
        }
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
      } finally {
        this.submitting = false;
      }
    },
    async confirmHandlePay() {
      if (this.paying) return;
      this.$confirm({
        title: this.labels.confirmPay.title,
        content: this.labels.confirmPay.subtitle,
        okText: this.labels.confirmPay.confirmButtonText,
        okType: "danger",
        icon: "close-circle",
        cancelText: this.labels.confirmPay.cancelButtonText,
        onOk: () => {
          this.handlePay();
        },
      });
    },
    async handlePay() {
      if (this.paying) return;
      this.paying = true;
      try {
        const response = await this.payPromotionRaffle(
          _.cloneDeep(this.promotionRaffle)
        );
        this.$message.success(response.message || this.labels.paidSuccess);
        this.fetchData();
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
      } finally {
        this.paying = false;
      }
    },
    handleCancel() {
      this.$router.push({ name: "admin.promotion-raffles" });
    },
    confirmClose() {
      this.$confirm({
        title: this.labels.closeConfirm.title,
        content: (h) =>
          h(
            "div",
            {
              class: "confirm-close-content",
            },
            [
              h("p", this.labels.closeConfirm.subtitle),
              h(
                "a-form-item",
                {
                  props: {
                    label: this.labels.form.winning_ticket.label,
                    labelCol: { span: 24 },
                  },
                },
                [
                  h("a-input", {
                    props: {
                      placeholder: this.labels.form.winning_ticket.placeholder,
                      value: this.form.winning_ticket,
                      allowClear: true,
                    },
                    on: {
                      input: (event) => {
                        this.form.winning_ticket = event.target.value;
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        okText: this.labels.closeConfirm.confirmButtonText,
        okType: "danger",
        icon: "close-circle",
        cancelText: this.labels.closeConfirm.cancelButtonText,
        onOk: async () => {
          try {
            if (!this.form.winning_ticket) {
              this.$notification.error({
                message: this.labels.form.winning_ticket.required,
                duration: 10,
              });
              return;
            }
            if (
              Number(this.form.winning_ticket) < this.form.start_sequence ||
              Number(this.form.winning_ticket) > this.form.end_sequence
            ) {
              this.$notification.error({
                message: this.labels.form.winning_ticket.invalidNumber
                  .replace("{min}", this.form.start_sequence)
                  .replace("{max}", this.form.end_sequence),
                duration: 10,
              });
              return;
            }
            this.form.status = RAFFLE_STATUS.CLOSED;
            await this.handleSubmit(false);
            this.$message.success(this.labels.closedSuccess);
          } catch (error) {
            this.$message.error(
              error?.response?.data?.message ||
                error?.response?.message ||
                error.message ||
                this.labels.closedError
            );
          }
        },
      });
    },
    async confirmInitiate() {
      if (this.form.end_date) {
        const startDate = moment.isMoment()
          ? this.form.start_date
          : moment(this.form.start_date);
        const endDate = moment.isMoment()
          ? this.form.end_date
          : moment(this.form.end_date);
        if (endDate.isBefore(startDate)) {
          this.$message.error(this.labels.endDateInvalid);
          return;
        }
      }

      this.$confirm({
        title: this.labels.confirm.title,
        content: this.labels.confirm.subtitle,
        okText: this.labels.confirm.confirmButtonText,
        okType: "danger",
        icon: "close-circle",
        cancelText: this.labels.confirm.cancelButtonText,
        onOk: async () => {
          try {
            this.form.status = RAFFLE_STATUS.INITIATED;
            await this.handleSubmit(false);
            this.$message.success(this.labels.initiatedSuccess);
          } catch (error) {
            this.$message.error(
              error?.response?.data?.message ||
                error?.response?.message ||
                error.message ||
                this.labels.deletedError
            );
          }
        },
      });
    },
  },
  watch: {
    "$route.params.id"(value, oldValue) {
      if (value && value !== oldValue) {
        this.fetchData();
      }
    },
    promotionRaffle: {
      handler(value) {
        Object.assign(
          this.form,
          value ? _.cloneDeep(value) : _.cloneDeep(initialFormState)
        );
      },
      deep: true,
    },
    "form.lottery": {
      handler(newVal, oldVal) {
        if (_.isEqual(newVal, oldVal)) return;
        if (newVal) {
          const weekDay = this.$moment()
            .lang("en")
            .format("dddd")
            .toLowerCase();
          const raffleTime = newVal[`${weekDay}_end_time`];
          const startDate = this.$moment(raffleTime, "HH:mm:ss");
          const endDate = this.$moment(raffleTime, "HH:mm:ss").add(1, "days");
          if (!this.form.start_date) {
            this.form.start_date = _.cloneDeep(endDate);
          }
          if (!this.form.end_date) {
            this.form.end_date = _.cloneDeep(endDate);
          }
          if (!this.form.raffle_date) {
            this.form.raffle_date = _.cloneDeep(startDate);
          }
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.form = _.cloneDeep(initialFormState);
    this.resetForm();
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.promotion-raffles-form {
  .form-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .form-icon {
    margin-right: 8px;
  }
  .form-button-group {
    margin-top: 16px;
  }
}
::v-deep {
  .ant-input[disabled],
  .ant-time-picker-input[disabled],
  .ant-input-number-disabled,
  .ant-select-disabled .ant-select-selection {
    background-color: color(--white) !important;
    color: rgba(0, 0, 0, 0.65) !important;
  }
}
</style>
<style lang="scss">
@import "~@/assets/scss/variable";
.promotion-raffles-form {
  .list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6px;
      &-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        max-width: 25%;
        width: 25%;
        border-right: 4px solid color(border);
        .success {
          color: color(success);
        }
        .warning {
          color: color(warning);
        }
        .danger {
          color: color(danger);
        }
        span {
          font-size: 14px;
          font-weight: 600;
        }
        small {
          font-size: 12px;
          font-weight: 400;
          padding-right: 4px;
        }
      }
      &-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2px;
        max-width: 50%;
        width: 50%;
        overflow: hidden;
        &-name,
        &-ticket_number {
          span {
            font-size: 16px;
            font-weight: 700;
            text-overflow: ellipsis;
          }
        }
        &-reference {
          span {
            font-size: 14px;
            font-weight: 500;
            text-overflow: ellipsis;
          }
        }
      }
      &-footer {
        max-width: 25%;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
        gap: 2px;
        &-status {
          width: 100%;
          span {
            font-size: 12px;
            font-weight: 400;
          }
          .ant-tag {
            padding: 0;
            margin: 0;
            padding-left: 2px;
            padding-right: 2px;
          }
        }
      }
    }
    &-actions {
      width: 100%;
      margin-top: 10px;
      .ant-btn-group {
        width: 100%;
        .more-info-button,
        .edit-button,
        .delete-button {
          width: 100%;
        }
      }
    }
  }
  .radio-view {
    display: flex;
    margin-bottom: 15px;
  }
  .radio-mobile-view {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
  }
}
</style>
